"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _styles = require("@material-ui/core/styles");
var _TimelineConnector = _interopRequireDefault(require("@material-ui/lab/TimelineConnector"));
var _TimelineContent = _interopRequireDefault(require("@material-ui/lab/TimelineContent"));
var _TimelineItem = _interopRequireDefault(require("@material-ui/lab/TimelineItem"));
var _TimelineOppositeContent = _interopRequireDefault(require("@material-ui/lab/TimelineOppositeContent"));
var _TimelineSeparator = _interopRequireDefault(require("@material-ui/lab/TimelineSeparator"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Badge = _interopRequireDefault(require("../../Badge"));
var _constants = require("../constants");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    badge: {
      backgroundColor: '#556E7A' // Unable to find in Fuse Theme
    },

    badgeContainer: {
      height: '100%'
    },
    contentConnector: {
      backgroundColor: '#95A8B1',
      // Unable to find in Fuse Theme
      marginBottom: '-8px',
      marginTop: '-8px',
      minHeight: theme.spacing(10)
    },
    dateGroupConnectorRoot: {
      minHeight: 0
    },
    dateGroupItemRoot: {
      minHeight: 0
    },
    hidden: {
      visibility: 'hidden'
    }
  };
});
var DaySeparator = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var date = props.date,
    disableConnector = props.disableConnector,
    textFormatter = props.textFormatter,
    TimelineConnectorProps = props.TimelineConnectorProps,
    TimelineOppositeContentProps = props.TimelineOppositeContentProps,
    TimelineSeparatorProps = props.TimelineSeparatorProps;
  var styles = useStyles();
  var label = typeof textFormatter === 'function' ? textFormatter(date) : date;
  return /*#__PURE__*/_react["default"].createElement(_TimelineItem["default"], {
    ref: ref,
    classes: {
      root: styles.dateGroupItemRoot
    }
  }, /*#__PURE__*/_react["default"].createElement(_TimelineOppositeContent["default"], TimelineOppositeContentProps), /*#__PURE__*/_react["default"].createElement(_TimelineSeparator["default"], TimelineSeparatorProps, /*#__PURE__*/_react["default"].createElement(_TimelineConnector["default"], (0, _extends2["default"])({
    classes: {
      root: (0, _classnames["default"])(styles.contentConnector, (0, _defineProperty2["default"])({}, styles.hidden, disableConnector))
    }
  }, TimelineConnectorProps))), /*#__PURE__*/_react["default"].createElement(_TimelineContent["default"], {
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    alignItems: "center",
    className: styles.badgeContainer,
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_Badge["default"], {
    className: styles.badge,
    label: label
  })))));
});
DaySeparator.displayName = 'DaySeparator';
DaySeparator.propTypes = process.env.NODE_ENV !== "production" ? {
  date: _propTypes["default"].string.isRequired,
  disableConnector: _propTypes["default"].bool,
  textFormatter: _propTypes["default"].func,
  TimelineConnectorProps: _constants.TimelineConnectorPropType,
  TimelineOppositeContentProps: _constants.TimelineOppositeContentPropType,
  TimelineSeparatorProps: _constants.TimelineSeparatorPropType
} : {};
var _default = DaySeparator;
exports["default"] = _default;